import { useEffect, useState } from "react";
import ColorTabs from "../components/ColorTobs";
import Blogs from "./Blog";
import News from "./News";
import '../styles/Blog.scss';
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import CaseStudies from "./CaseStudies";
import { useNavigate, useParams } from "react-router-dom";


const Resources = () => {
    const navigate = useNavigate();
    const { resourcetype } = useParams<{ resourcetype: string }>();
    const [activeTab, setActiveTab] = useState(resourcetype || 'Blogs');
    const [tabContent, setTabContent] = useState<any>(null);

    useEffect(() => {
        setActiveTab(resourcetype || 'Blogs');
    }, [resourcetype]);

    const handleTabContent = () => {
        console.log('Active Tab:', activeTab);
        switch (activeTab) {
            case 'Blogs':
                setTabContent(<Blogs />);
                break;
            case 'Case Studies':
                setTabContent(<CaseStudies />);
                break;
            case 'News':
                setTabContent(<News />);
                break;
            default:
                return null;
        }
    };

    useEffect(() => {
        handleTabContent();
    }, [activeTab]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        console.log('Active Tab:', newValue);
        navigate(`/Resources/${newValue}`);
        // setActiveTab(newValue);
        // handleTabContent();
    };

    return (
        <div>
            <div className="color-tabs-container">
                <ColorTabs
                    handleChange={handleTabChange}
                    activeTab={activeTab}
                    tabContent={tabContent}
                    tabs={[
                        {
                            value: 'Blogs',
                            label: 'Blogs'
                        },
                        {
                            value: 'Case Studies',
                            label: 'Case Studies'
                        },
                        {
                            value: 'News',
                            label: 'News'
                        }
                    ]}
                />
            </div>
            <ContactForm />
            <Footer />
        </div>
    );
};

export default Resources;